// extracted by mini-css-extract-plugin
export default {"none":"Loading_none__SGlXi","loading":"Loading_loading__YIwhI","uil_ring_css":"Loading_uil_ring_css__EriSd","uil-ring-anim":"Loading_uil-ring-anim__K2gLQ"};